(function () {
  'use strict';

  var recentlyViewedTimer = 0;
  function hydrateRecentlyViewedImmediately(scope) {
    var element = scope && scope.querySelector('recently-viewed-products');
    if (!element) return;

    var hydrate = function () {
      if (typeof element.handleIntersection !== 'function') return;
      if (element.observer && typeof element.observer.unobserve === 'function') {
        element.observer.unobserve(element);
      }
      Promise.resolve(element.handleIntersection(
        [{ isIntersecting: true }],
        { unobserve: function () {} }
      )).catch(function () {});
    };

    if (window.customElements && typeof window.customElements.whenDefined === 'function') {
      window.customElements.whenDefined('recently-viewed-products').then(hydrate).catch(function () {});
    } else {
      hydrate();
    }
  }

  function refreshRecentlyViewedSection() {
    var root = document.querySelector('[data-bot-recently-viewed][data-section-id]');
    if (!root) return;
    window.clearTimeout(recentlyViewedTimer);
    recentlyViewedTimer = window.setTimeout(function () {
      var id = root.getAttribute('data-section-id');
      var url = new URL(window.location.href);
      url.searchParams.set('section_id', id);
      fetch(url.toString(), { credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (response) { return response.ok ? response.text() : Promise.reject(new Error('Section refresh failed')); })
        .then(function (html) {
          var parser = new DOMParser();
          var next = parser.parseFromString(html, 'text/html').querySelector('[data-bot-recently-viewed]');
          var current = document.querySelector('[data-bot-recently-viewed]');
          if (next && current) {
            current.replaceWith(next);
            hydrateRecentlyViewedImmediately(next);
          }
        })
        .catch(function () {});
    }, 180);
  }

  var shopByConcernRows = [
    { handle: 'anti-aging', label: 'Fine lines & wrinkles' },
    { handle: 'dry-skin', label: 'Dryness' },
    { handle: 'dull-skin', label: 'Dullness' },
    { handle: 'large-pores', label: 'Visible pores' },
    { handle: 'dark-marks', label: 'Dark marks' },
    { handle: 'acne', label: 'Acne' },
    { handle: 'blemishes', label: 'Blemishes' },
    { handle: 'brightening', label: 'Brightening' },
    { handle: 'hyperpigmentation', label: 'Hyperpigmentation' },
    { handle: 'oily-skin', label: 'Oily skin' },
    { handle: 'texture', label: 'Texture' }
  ];

  function currentCollectionHandle() {
    var match = window.location.pathname.match(/^\/collections\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]).toLowerCase() : '';
  }

  function activeConcern() {
    var handle = currentCollectionHandle();
    return shopByConcernRows.find(function (row) { return row.handle === handle; }) || null;
  }

  function isShopByConcernLanding() {
    return currentCollectionHandle() === 'skincare' &&
      new URLSearchParams(window.location.search).get('view') === 'shop-by-concern';
  }

  function alignConcernChip(hero) {
    var scroller = hero && hero.querySelector('.bot-concern-hero__chips');
    var selected = scroller && scroller.querySelector('[aria-current="page"]');
    if (!scroller || !selected) return;
    var leftPadding = parseFloat(window.getComputedStyle(scroller).paddingLeft) || 0;
    scroller.scrollTo({
      left: Math.max(0, selected.offsetLeft - leftPadding),
      behavior: 'auto'
    });
  }

  function initShopByConcernNavigation() {
    var tabScroller = document.querySelector('.tabs-wrapper');
    if (!tabScroller) return;

    var concernTab = tabScroller.querySelector('[data-bot-concern-tab]');
    if (!concernTab) {
      concernTab = document.createElement('a');
      concernTab.href = '/collections/skincare?view=shop-by-concern';
      concernTab.textContent = 'Shop by Concern';
      concernTab.setAttribute('data-bui-tab', '');
      concernTab.setAttribute('data-bot-concern-tab', 'true');
      var skincareTab = Array.prototype.find.call(
        tabScroller.querySelectorAll('a[data-bui-tab]'),
        function (tab) { return tab.getAttribute('href') === '/collections/skincare'; }
      );
      if (skincareTab) skincareTab.insertAdjacentElement('afterend', concernTab);
      else tabScroller.appendChild(concernTab);
    }

    var selectedConcern = activeConcern();
    var concernContext = isShopByConcernLanding() || Boolean(selectedConcern);
    if (concernContext) {
      tabScroller.querySelectorAll('a[data-bui-tab]').forEach(function (tab) {
        tab.classList.remove('bot-tab-current');
        tab.removeAttribute('aria-current');
      });
      concernTab.classList.add('bot-tab-current');
      concernTab.setAttribute('aria-current', 'page');
    }

    var hero = document.querySelector('.bot-concern-hero');
    if (hero) {
      var activeHandle = selectedConcern && selectedConcern.handle;
      hero.querySelectorAll('.bot-concern-chip').forEach(function (chip) {
        var href = new URL(chip.href, window.location.origin);
        var handleMatch = href.pathname.match(/^\/collections\/([^/?#]+)/);
        var chipHandle = handleMatch ? decodeURIComponent(handleMatch[1]).toLowerCase() : '';
        var isAll = chipHandle === 'skincare' && href.searchParams.get('view') === 'shop-by-concern';
        var isCurrent = activeHandle ? chipHandle === activeHandle : isShopByConcernLanding() && isAll;
        if (isCurrent) chip.setAttribute('aria-current', 'page');
        else chip.removeAttribute('aria-current');
      });
      window.requestAnimationFrame(function () { alignConcernChip(hero); });
    }
  }

  function initRecentlyViewedRefresh() {
    var root = document.querySelector('[data-bot-recently-viewed]');
    if (!root || root.dataset.refreshReady === 'true') return;
    root.dataset.refreshReady = 'true';
    document.addEventListener('product:added-to-cart', refreshRecentlyViewedSection);
    document.addEventListener('cart:updated', refreshRecentlyViewedSection);
    var bubble = document.getElementById('CartBubble') || document.querySelector('.cart-count-bubble');
    if (bubble && window.MutationObserver) {
      new MutationObserver(refreshRecentlyViewedSection).observe(bubble, { childList: true, subtree: true, characterData: true });
    }
  }

  function initShoppingNavigationState() {
    var dock = document.querySelector('.bottom-nav');
    if (dock) {
      var home = dock.querySelector(':scope > a');
      var shop = dock.querySelector('#shopBtn1');
      var stores = dock.querySelector('#shopBtn2');
      var navigationItems = [home, shop, stores].filter(Boolean);
      var darkAppearance = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)');
      var syncDockContrast = function () {
        navigationItems.forEach(function (item) {
          var selected = item.classList.contains('bot-nav-current') || item.getAttribute('aria-current') === 'page';
          var forceDarkInk = Boolean(darkAppearance && darkAppearance.matches && selected);
          [item].concat(Array.from(item.querySelectorAll('svg, span'))).forEach(function (element) {
            if (forceDarkInk) {
              element.style.setProperty('color', '#111', 'important');
              element.dataset.botDarkDockInk = 'true';
            } else if (element.dataset.botDarkDockInk === 'true') {
              element.style.removeProperty('color');
              delete element.dataset.botDarkDockInk;
            }
          });
        });
      };
      var path = window.location.pathname.replace(/\/+$/, '') || '/';
      var shoppingPath = /^\/(collections|products|search)(\/|$)/.test(path) ||
        path === '/pages/brands' || /^\/pages\/ingredient-/.test(path);
      var storesPath = path === '/pages/locations';

      navigationItems.forEach(function (item) {
        item.classList.remove('bot-nav-current');
        item.removeAttribute('aria-current');
      });

      var routeActive = path === '/' ? home : (storesPath ? stores : (shoppingPath ? shop : null));
      var active = routeActive;
      if (active) {
        active.classList.add('bot-nav-current');
        active.setAttribute('aria-current', 'page');
      }

      syncDockContrast();
      if (window.MutationObserver) {
        navigationItems.forEach(function (item) {
          new MutationObserver(syncDockContrast).observe(item, {
            attributes: true,
            attributeFilter: ['class', 'aria-current']
          });
        });
      }
      if (darkAppearance) {
        if (darkAppearance.addEventListener) darkAppearance.addEventListener('change', syncDockContrast);
        else if (darkAppearance.addListener) darkAppearance.addListener(syncDockContrast);
      }

      var normalizeDockLens = function () {
        var lenses = Array.from(dock.querySelectorAll(':scope > .bn-lens'));
        if (!lenses.length) return null;
        var nativeLens = lenses.find(function (lens) {
          return lens.dataset.botFallbackLens !== 'true';
        });
        var lens = nativeLens || lenses[0];
        lenses.forEach(function (candidate) {
          if (candidate !== lens) candidate.remove();
        });
        return lens;
      };

      var alignCurrentDockLens = function () {
        if (!active) return;
        var lens = normalizeDockLens();
        if (!lens) {
          lens = document.createElement('span');
          lens.className = 'bn-lens';
          lens.setAttribute('aria-hidden', 'true');
          lens.dataset.botFallbackLens = 'true';
          dock.appendChild(lens);
        }
        var items = Array.prototype.filter.call(dock.children, function (item) {
          return item.matches('a, button');
        });
        items.forEach(function (item) {
          item.classList.toggle('bn-active', item === active);
          item.style.transform = item === active
            ? 'translateY(-1.2px) scale(1.035)'
            : '';
        });
        var dockRect = dock.getBoundingClientRect();
        var activeRect = active.getBoundingClientRect();
        lens.style.width = (activeRect.width + 6) + 'px';
        lens.style.setProperty('--bui-lens-energy', '0.000');
        lens.style.transform = 'translateX(' +
          (activeRect.left - dockRect.left - 3) + 'px) scale(1, 1)';
      };

      var setDockActive = function (nextActive) {
        navigationItems.forEach(function (item) {
          item.classList.toggle('bot-nav-current', item === nextActive);
          if (item === nextActive) item.setAttribute('aria-current', 'page');
          else item.removeAttribute('aria-current');
        });
        active = nextActive;
        syncDockContrast();
      };

      var shopModal = document.getElementById('shopModal1');
      var storesModal = document.getElementById('shopModal2');
      var syncModalDockState = function () {
        var shopOpen = shopModal && shopModal.getAttribute('aria-hidden') === 'false';
        var storesOpen = storesModal && storesModal.getAttribute('aria-hidden') === 'false';
        setDockActive(shopOpen ? shop : (storesOpen ? stores : routeActive));
      };

      [[shop, shop], [stores, stores]].forEach(function (entry) {
        var trigger = entry[0];
        var nextActive = entry[1];
        if (!trigger) return;
        trigger.addEventListener('click', function () {
          setDockActive(nextActive);
        }, true);
      });
      if (window.MutationObserver) {
        [shopModal, storesModal].filter(Boolean).forEach(function (modal) {
          new MutationObserver(syncModalDockState).observe(modal, {
            attributes: true,
            attributeFilter: ['aria-hidden']
          });
        });
      }

      alignCurrentDockLens();
      if (window.MutationObserver) {
        var dockObserver = new MutationObserver(function () {
          window.requestAnimationFrame(alignCurrentDockLens);
        });
        dockObserver.observe(dock, { childList: true });
      }

      /* The liquid-lens controller initializes after this enhancement on some
         cached mobile pages. Re-apply the route state once initialization has
         settled, then leave later customer taps free to move the single lens. */
      var settleCurrentDock = function () {
        window.requestAnimationFrame(alignCurrentDockLens);
        window.requestAnimationFrame(syncDockContrast);
      };
      if (document.readyState === 'complete') settleCurrentDock();
      else window.addEventListener('load', settleCurrentDock, { once: true });
    }

    var selectedTab = document.querySelector('.tabs-wrapper [data-bui-tab][aria-current="page"]');
    if (selectedTab) {
      selectedTab.classList.add('bot-tab-current');
      var alignSelectedTabStart = function () {
        var tabScroller = selectedTab.closest('.tabs-wrapper');
        if (!tabScroller) return;
        var leftPadding = parseFloat(window.getComputedStyle(tabScroller).paddingLeft) || 0;
        tabScroller.scrollTo({
          left: Math.max(0, selectedTab.offsetLeft - leftPadding),
          behavior: 'auto'
        });
      };
      window.requestAnimationFrame(alignSelectedTabStart);
      var settleSelectedTab = function () {
        window.requestAnimationFrame(alignSelectedTabStart);
      };
      if (document.readyState === 'complete') settleSelectedTab();
      else window.addEventListener('load', settleSelectedTab, { once: true });
    }
  }

  function initSoldOutCardActions() {
    document.querySelectorAll('.products-collection-grid .product-card').forEach(function (card) {
      if (card.querySelector('[data-bui-card-cart], [data-bot-sold-out-action]')) return;
      if (!card.querySelector('.sold-out-badge')) return;

      var title = card.querySelector('.product-card__title');
      var slot = document.createElement('div');
      var button = document.createElement('button');
      var label = document.createElement('span');
      slot.className = 'bot-card-quick-add-slot';
      slot.setAttribute('data-bot-sold-out-action', '');
      button.className = 'button button-light bot-card-quick-add-button';
      button.type = 'button';
      button.disabled = true;
      button.setAttribute('aria-label', 'Sold out: ' + (title ? title.textContent.trim() : 'product'));
      label.textContent = 'Sold out';
      button.appendChild(label);
      slot.appendChild(button);
      card.appendChild(slot);
    });
  }

  function productHeaderIcon(name) {
    var icons = {
      back: '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m15 18-6-6 6-6"></path></svg>',
      search: '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="11" cy="11" r="7"></circle><path d="m16.5 16.5 4 4"></path></svg>',
      cart: '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M3.5 9h17l-1.7 11H5.2L3.5 9Z"></path><path d="m7.5 9 4.5-6 4.5 6M8 13h8M8.5 16.5h7"></path></svg>',
      menu: '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M4 7h16M4 12h16M4 17h16"></path></svg>',
      heart: '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1.1-1.1a5.5 5.5 0 0 0-7.8 7.8l1.1 1.1L12 21l7.8-7.5 1.1-1.1a5.5 5.5 0 0 0-.1-7.8Z"></path></svg>'
    };
    return icons[name] || '';
  }

  function readCartCount() {
    var source = document.getElementById('CartBubble') || document.querySelector('.cart-count-bubble');
    if (!source) return 0;
    var match = source.textContent.match(/\d+/);
    return match ? parseInt(match[0], 10) : 0;
  }

  function updateProductHeaderCartCount(header) {
    if (!header) return;
    var badge = header.querySelector('.bot-mobile-product-cart-count');
    if (!badge) return;
    var count = readCartCount();
    badge.textContent = String(count);
    badge.setAttribute('data-has-items', count > 0 ? 'true' : 'false');
  }

  function initMobileProductPage() {
    if (!document.body.classList.contains('product-page')) return;

    var main = document.querySelector('.section-main-product .main-product-template');
    var info = main && main.querySelector('.product-info-inner');
    var titleSource = info && info.querySelector('.product-name-wrapper h1');
    if (!main || !info || !titleSource) return;

    var header = main.querySelector(':scope > .bot-mobile-product-header');
    if (!header) {
      header = document.createElement('nav');
      header.className = 'bot-mobile-product-header';
      header.setAttribute('aria-label', 'Product navigation');
      header.innerHTML =
        '<button class="bot-mobile-product-back" type="button" data-bot-product-back>' +
          productHeaderIcon('back') + '<span>Back</span>' +
        '</button>' +
        '<span class="bot-mobile-product-title"></span>' +
        '<span class="bot-mobile-product-actions">' +
          '<button class="bot-mobile-product-action" type="button" aria-label="Search" data-bot-product-search>' + productHeaderIcon('search') + '</button>' +
          '<a class="bot-mobile-product-action" href="/cart" aria-label="Cart">' + productHeaderIcon('cart') + '<span class="bot-mobile-product-cart-count" aria-hidden="true"></span></a>' +
          '<button class="bot-mobile-product-action" type="button" aria-label="Open menu" data-bot-product-menu>' + productHeaderIcon('menu') + '</button>' +
        '</span>';
      main.insertBefore(header, main.firstChild);

      header.querySelector('.bot-mobile-product-title').textContent = titleSource.textContent.trim();
      header.querySelector('[data-bot-product-back]').addEventListener('click', function () {
        if (window.history.length > 1) window.history.back();
        else window.location.assign('/');
      });
      header.querySelector('[data-bot-product-search]').addEventListener('click', function () {
        var search = document.querySelector('header.contents button[aria-label="Search"]');
        if (search) search.click();
        else window.location.assign('/search');
      });
      header.querySelector('[data-bot-product-menu]').addEventListener('click', function () {
        var menu = document.getElementById('shopBtn1') || document.querySelector('header.contents .hamburger');
        if (menu) menu.click();
      });
    }

    if (!info.querySelector(':scope > .bot-mobile-product-wishlist')) {
      var wishlist = document.createElement('a');
      wishlist.className = 'bot-mobile-product-wishlist iwishDrawer';
      wishlist.href = '/pages/wishlist';
      wishlist.setAttribute('aria-label', 'View wishlist');
      wishlist.innerHTML = productHeaderIcon('heart');
      info.insertBefore(wishlist, info.firstChild);
    }

    var picker = info.querySelector('.product-variant-picker');
    if (picker) {
      var groups = Array.prototype.slice.call(picker.querySelectorAll('fieldset'));
      var onlySingleValues = groups.length > 0 && groups.every(function (group) {
        return group.querySelectorAll('input[type="radio"]:not([disabled])').length <= 1;
      });
      picker.classList.toggle('bot-single-value-options', onlySingleValues);
    }

    updateProductHeaderCartCount(header);
    var bubble = document.getElementById('CartBubble') || document.querySelector('.cart-count-bubble');
    if (bubble && window.MutationObserver && bubble.dataset.botProductHeaderObserved !== 'true') {
      bubble.dataset.botProductHeaderObserved = 'true';
      new MutationObserver(function () {
        updateProductHeaderCartCount(document.querySelector('.bot-mobile-product-header'));
      }).observe(bubble, { childList: true, subtree: true, characterData: true });
    }
  }

  function init() {
    initRecentlyViewedRefresh();
    initShopByConcernNavigation();
    initShoppingNavigationState();
    initSoldOutCardActions();
    initMobileProductPage();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
